import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Link, useLocation, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import styles from './SeancePage.module.css';
import stylesForm from '../../components/Form/Form.module.css';
import RatingBox from "../../components/Rating/RatingBox";
import useRating from "../../hooks/useRating";
import {getRatingApi, getRatingLocal} from "../../services/RatingService";
import {
    afficherRating,
    afficherRegisterButton,
    afficherRegisterFileAttenteButton,
    afficherUnregisterButton,
    getRatingColor,
    getSeanceApi,
    getSeanceLocal,
    PARTICIPATION_STATUS,
    registerUserToSeanceAPI,
    SEANCE_STATUS,
    unregisterUserToSeanceAPI
} from "../../services/SeanceService";
import { useModal } from '../../contexts/ModalContext';
import ListSwitch from "../../components/List/ListSwitch";
import {Formik} from "formik";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt,
    faChair,
    faCheckCircle,
    faCircleExclamation,
    faClockRotateLeft,
    faExclamation,
    faFlag,
    faPersonRunning,
    faUserSlash,
} from '@fortawesome/free-solid-svg-icons';
import AddPeopleForm from "../../components/Form/AddPeopleForm";
import BlocLocation from "../../components/Bloc/BlocLocation";
import {useUser} from "../../contexts/UserContext";
import {
    parseParticipants,
    setDesinscrireParticipantByReferent,
    setPresenceParticipant
} from "../../services/UserService";
import axiosConfig from "../../services/AxiosConfig";
import AxiosConfig from "../../services/AxiosConfig";
import {useBreadcrumb} from "../../contexts/BreadcrumbContext";
import {ImageIllustration} from "../../components/Image/ImageIllustration";
import TitleSecondary from "../../components/Title/TitleSecondary";
import TextAreaCustom from "../../components/Field/TextAreaCustom";
import BtnSave from "../../components/Button/BtnSave";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";
import { openCalendar } from "../../services/AgendaService";
import { ReactComponent as OutlookIcon } from "../../icons/outlook.svg";
import { ReactComponent as GoogleAgendaIcon } from "../../icons/google_agenda.svg";
import { ReactComponent as Office365Icon } from "../../icons/office365.svg";
import SearchCoach from "../../components/Search/SearchCoach";
import styles_modal from "../../components/Modal/Modal.module.css";


function SeancePage() {
    const { user } = useUser();
    const { id } = useParams();
    const location = useLocation();
    const [seance, setSeance] = useState(null);
    const [initialRating, setInitialRating] = useState(0);
    const [listData, setListData] = useState([]);
    const [listParticipants, setListParticipants] = useState([]);
    const { showModal } = useModal();
    const { updateBreadcrumb } = useBreadcrumb();
    const [smsCharCount, setSmsCharCount] = useState(0);

    const btnContainerRef = useRef(null);
    const [btnPosition, setBtnPosition] = useState(null);
    const isFixedRef = useRef(false);

    const getPosition = () => {
        if (btnContainerRef.current) {
            const rect = btnContainerRef.current.getBoundingClientRect();
            setBtnPosition({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            });

            const threshold = 1;  // Seuil pour éviter les fluctuations
            const shouldFix = (rect.bottom + rect.height) > (window.scrollY + window.innerHeight + threshold);

            if (shouldFix !== isFixedRef.current) {
                isFixedRef.current = shouldFix;
            }
        }
    };


    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 5000 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 5000 });
    }, [showModal]);

    const getSeanceData = async () => {
        const getSeance = process.env.REACT_APP_MODE === 'maquette' ? getSeanceLocal : getSeanceApi;
        const data = await getSeance(+id);
        if (data.success === true) {
            setSeance(data.seance);
            // setSeance(data.seance);
            setListData(parseParticipants(data.seance.participants));
            setListParticipants(data.seance.listParticipantsForReferent);
            const breadcrumbName = data.seance.titre + ' - ' + DateService.formatDate(new Date(data.seance.date));
            updateBreadcrumb([{ name: breadcrumbName, path: location.pathname }]);
        } else {
            console.error("Une erreur est survenue lors de la récupération de la séance");
            handleError(data.msg);
        }
    }

    useEffect(() => {
        getSeanceData().then(r => r).catch((err) => {  });
    }, [id]);

    useEffect(() => {
        if (afficherRating(seance)) {
            const getRating = process.env.REACT_APP_MODE === 'maquette' ? getRatingLocal : getRatingApi;
            getRating(+id)
            .then((data) => {
                if (data && data.value && data.value.value) {
                    setInitialRating(data.value.value);
                }
            })
            .catch((err) => {
                console.error('Une erreur est survenue lors de la récupération de la note: ', err);
                handleError("Une erreur est survenue lors de la récupération de la note");
            });
        }
    }, [seance]);

    const [rating, handleRatingChange, error, setUserHasInteracted] = useRating(initialRating, id, handleSuccess);

    useEffect(() => {
        if (error) {
            handleError(error);
        }
    }, [error]);

    useEffect(() => {
        const handleScroll = () => {
            setTimeout(() => {
                getPosition();
            }, 200);
        };

        window.addEventListener("scroll", handleScroll);

        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    if (!seance) return (<div className="content">
        <TitleMain text="Séance non trouvée"/>
        <Link to={user ? Routing.routes.home : Routing.routes.login }>Retour à l'accueil</Link>
    </div>);

    const handleToggleSwitch = async (key) => {
        if (seance.status !== 1) return handleError("La séance n'est pas active, vous ne pouvez pas modifier la présence des participants.");
        if (seance.coach.absence === true) return handleError("Vous ne pouvez pas modifier la présence des participants.");

        let presence = null;
        const newListData = listData.map(item => {
            if (item.key === key) {
                presence = !item.isSwitchActive;
                return { ...item, isSwitchActive: presence };
            }
            return item;
        });

        const result = await setPresenceParticipant(seance.id, key, presence);
        if (result.success) {
            handleSuccess(result.msg);
        } else {
            handleError(result.msg);
        }
        setListData(newListData);
    };

    const handleRegister = async () => {
        if (seance.status !== 1) return handleError("Cette séance n'est pas active, vous ne pouvez pas vous inscrire.");

        const fetchThat = async () => {
            const response = await registerUserToSeanceAPI(seance.id)
            if (!response.success) {
                console.error(response);
                handleError(response.msg);
            } else {
                handleSuccess(response.msg);
                setSeance({ ...seance, userRegistered: true, asu_status: response.asu_status, placesRestantes: response.placesRestantes,});
            }
        }

        showModal('confirm', {
            message: "Êtes-vous sûr de vouloir vous inscrire à la séance ?",
            onConfirm: fetchThat,
        });
    };

    const displayLinkToAgenda = () => {
        // Vérification que nous avons bien les données de la séance
        if (!seance || !seance.date) {
            console.error('Données de séance manquantes pour créer le lien agenda');
            return;
        }

        // Construction de l'URL Outlook Calendar
        const generateOutlookCalendarUrl = (seanceData) => {
            // URL de base pour Outlook Calendar
            const baseUrl = 'https://outlook.office.com/calendar/0/action/compose';

            // Conversion de la date de séance en objet Date
            const startDate = new Date(seanceData.date);

            // Calcul de la date de fin (date de début + durée en minutes)
            const endDate = new Date(startDate.getTime() + (seanceData.duree * 60 * 1000));

            // Formatage des dates au format ISO requis par Outlook (YYYY-MM-DDTHH:mm:ss)
            const formatDateForOutlook = (date) => {
                return date.toISOString().slice(0, 19); // Supprime les millisecondes et le 'Z'
            };

            // Construction du titre de l'événement
            const eventTitle = `${seanceData.titre} - ${seanceData.type.description}`;

            // Construction de la description de l'événement
            const eventDescription = `Séance de ${seanceData.type.description} avec ${seanceData.coach.prenom}.\n\nDurée: ${seanceData.duree} minutes\nLieu: ${seanceData.lieu.nom}\nAdresse: ${seanceData.lieu.adresse || ''}`;

            // Construction de la localisation
            const eventLocation = seanceData.lieu.nom + (seanceData.lieu.adresse ? `, ${seanceData.lieu.adresse}` : '');

            // Paramètres de l'URL
            const params = new URLSearchParams({
                allday: 'false', // Événement avec heure précise
                subject: eventTitle, // Titre de l'événement
                body: eventDescription, // Description de l'événement
                location: eventLocation, // Lieu de l'événement
                startdt: formatDateForOutlook(startDate), // Date et heure de début
                enddt: formatDateForOutlook(endDate), // Date et heure de fin
                path: '/calendar/action/compose', // Chemin requis par Outlook
                rru: 'addevent' // Paramètre requis par Outlook
            });

            return `${baseUrl}?${params.toString()}`;
        };

        // Génération de l'URL
        const outlookUrl = generateOutlookCalendarUrl(seance);

        // Création et affichage du modal avec le lien
        const modalContent = (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <h3>Ajouter à votre agenda</h3>
                <p>Cliquez sur le bouton ci-dessous pour ajouter cette séance à votre agenda Outlook :</p>
                <div style={{ margin: '20px 0' }}>
                    <strong>{seance.titre}</strong><br/>
                    <span>{DateService.formatDate(new Date(seance.date))}</span><br/>
                    <span>Durée: {seance.duree} minutes</span><br/>
                    <span>Lieu: {seance.lieu.nom}</span>
                </div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <a
                        href={outlookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn_primary"
                        style={{ textDecoration: 'none', color: 'white' }}
                    >
                        📅 Ajouter à Outlook
                    </a>
                    <button
                        className="btn btn_secondary"
                        onClick={() => {
                            // Copier le lien dans le presse-papiers
                            navigator.clipboard.writeText(outlookUrl).then(() => {
                                handleSuccess('Lien copié dans le presse-papiers !');
                            }).catch(() => {
                                handleError('Impossible de copier le lien');
                            });
                        }}
                    >
                        📋 Copier le lien
                    </button>
                </div>
                <p style={{ fontSize: '0.9em', color: '#666', marginTop: '15px' }}>
                    Note: Ce lien fonctionne avec Outlook Web et l'application Outlook
                </p>
            </div>
        );

        // Affichage du modal
        showModal('info', {
            children: modalContent,
            timeout: 0 // Pas de fermeture automatique
        });
    };


    const handleRegisterFileAttente = async () => {
        if (seance.status !== 1) return handleError("Cette séance n'est pas active, vous ne pouvez pas vous inscrire en file d'attente.");

        const fetchThat = async () => {
            const response = await registerUserToSeanceAPI(seance.id, true)
            if (!response.success) {
                console.error(response);
                handleError(response.msg);
            } else {
                handleSuccess(response.msg);
                setSeance({ ...seance, userRegistered: true, asu_status: response.asu_status, placesRestantes: response.placesRestantes,});
            }
        }

        showModal('confirm', {
            message: "Je veux participer à ce cours si une place se libère ?",
            onConfirm: fetchThat,
        });
    }

    const handleUnregister = async () => {
        if (seance.status !== 1) return handleError("Cette séance n'est pas active, vous ne pouvez pas vous désinscrire.");

        const fetchThat = async () => {
            const response = await unregisterUserToSeanceAPI(seance.id)
            if (!response.success) {
                console.error(response);
                handleError(response.msg);
            } else {
                handleSuccess(response.msg);
                setSeance({ ...seance, userRegistered: false, asu_status: response.asu_status, placesRestantes: response.placesRestantes,});
            }
        }

        showModal('confirm', {
            message: "Êtes-vous sûr de vouloir vous désinscrire de la séance ?",
            onConfirm: fetchThat,
        });
    };

    // Fonction pour déterminer si le bouton agenda doit être affiché
    const shouldShowAgendaButton = (seance, user) => {
        // Vérifications de base : séance et utilisateur existent
        if (!seance || !user) return false;

        // L'utilisateur doit avoir le rôle USER ou REFERENT pour voir le bouton
        if (!user.roles.includes('ROLE_USER') && !user.roles.includes('ROLE_REFERENT')) {
            return false;
        }

        // La séance ne doit pas être annulée
        if (seance.status === SEANCE_STATUS.annule.value) {
            return false;
        }

        // L'utilisateur doit être inscrit à la séance
        if (!seance.userRegistered) {
            return false;
        }

        // La séance ne doit pas être passée depuis plus de 24h
        // Cela évite d'encombrer l'agenda avec des événements très anciens
        const seanceDate = new Date(seance.date);
        const now = new Date();
        const daysSinceSeance = (now.getTime() - seanceDate.getTime()) / (1000 * 60 * 60 * 24);

        // On affiche le bouton si la séance est future ou passée depuis moins de 1 jour
        return daysSinceSeance < 1;
    };

    // Action pour ouvrir le lien Outlook
    const handleOpenOutlookCalendar = () => {
        openCalendar('outlook', seance, handleSuccess, handleError);
    };

    const handleOpenGoogleCalendar = () => {
        openCalendar('google', seance, handleSuccess, handleError);
    }

    const handleOpenOffice365Calendar = () => {
        openCalendar('office365', seance, handleSuccess, handleError);
    }

    // Composant pour afficher les boutons agenda
    function AgendaButtons() {
        // On vérifie si on doit afficher les boutons
        if (!shouldShowAgendaButton(seance, user)) {
            return null;
        }

        return (
            <div className={styles.agendaButtonsContainer} style={{
                marginTop: '20px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                textAlign: 'center'
            }}>
                <p style={{
                    margin: '0 0 15px 0',
                    fontSize: '0.9em',
                    color: '#666'
                }}>
                    📅 Ajoutez cette séance à votre agenda :
                </p>

                <div style={{
                    display: 'flex',
                    gap: '24px',
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                }}>
                    <button
                        onClick={handleOpenOutlookCalendar}
                        className="btn btn_primary"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            backgroundColor: "#d1edff",
                            border: '1px solid #a0c4e6',
                            color: '#114c8a',
                            width: '120px',
                        }}
                    >
                        <OutlookIcon style={{ width: "48px", height: "48px"}}/>Outlook
                    </button>

                    <button
                        onClick={handleOpenGoogleCalendar}
                        className="btn btn_primary"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            color: '#114c8a',
                            backgroundColor: "#ffe398",
                            border: '1px solid #f0c14b',
                            width: '120px',
                        }}
                    >
                        <GoogleAgendaIcon style={{ width: "48px", height: "48px"}}/>Google Agenda
                    </button>

                    <button
                        onClick={handleOpenOffice365Calendar}
                        className="btn btn_primary"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            color: '#114c8a',
                            backgroundColor: "#ced5fa",
                            border: '1px solid #a0a8d3',
                            width: '120px',
                        }}
                    >
                        <Office365Icon style={{ width: "48px", height: "48px"}}/>Office 365
                    </button>
                </div>

                <p style={{
                    margin: '10px 0 0 0',
                    fontSize: '0.8em',
                    color: '#888'
                }}>
                    Compatible avec Outlook Web, Outlook Desktop, l'app mobile, Google Agenda et Office 365
                </p>
            </div>
        );
    }


    function SeanceActions() {
        if (!user.roles.includes('ROLE_USER') && !user.roles.includes('ROLE_REFERENT')) return null;

        if (afficherRating(seance)) {
            return (
                <RatingBox
                    label="Notez cette séance"
                    count={5}
                    value={rating}
                    onChange={(newValue) => {
                        handleRatingChange(newValue);
                        setUserHasInteracted(true);
                    }}
                    color="transparent"
                    filledColor={getRatingColor(seance)}
                    hoverColor="#f1c40f"
                />
            );
        }

        const aub = afficherUnregisterButton(seance);
        const arfab = afficherRegisterFileAttenteButton(seance);
        const arb = afficherRegisterButton(seance);

        if (aub) {
            return (
                <div>
                    {renderBtnContainer(renderUnregisterButton(seance))}
                    {/* Ajout des boutons agenda après les boutons d'action */}
                    <AgendaButtons />
                </div>
            );
        }
        if (arfab) {
            return renderBtnContainer(renderRegisterFileAttenteButton(seance));
        }
        if (arb) {
            return renderBtnContainer(renderRegisterButton(seance));
        }

        return <AgendaButtons />;
    }

    function renderBtnContainer(content) {
        return (
            <div style={{ minHeight: "36px"}}>
                <div ref={btnContainerRef}
                     className={`btn_container ${isFixedRef.current ? 'btn_container_fixed' : ''}`}
                >
                    {content}
                </div>
            </div>
        );
    }

    function renderRegisterButton(seance) {
        return (
            <button onClick={handleRegister} className="btn btn_success majuscule bold">
                Je souhaite participer
            </button>
        );
    }

    function renderRegisterFileAttenteButton(seance) {
        return (
            <button onClick={handleRegisterFileAttente} className="btn btn_warn majuscule bold">
                Je m’inscris en file d’attente
            </button>
        );
    }

    function renderUnregisterButton(seance) {
        const fileAttente = [PARTICIPATION_STATUS.file_attente.value , PARTICIPATION_STATUS.file_attente_non_prio.value].includes(seance.asu_status);
        const buttonText = fileAttente
            ? "Se désinscrire de la file d'attente"
            : "Je ne souhaite plus participer";

        return (
            <button onClick={handleUnregister}
                    className={`btn ${seance.asu_status === 0 ? 'btn_danger' : 'btn_danger'} majuscule bold`}>
                {buttonText}
            </button>
        );
    }


    async function validerAppel() {
        const fetchThat = async () => {
            const response = await axiosConfig.post(`/seances/seance/valider_appel/${seance.id}`);

            if (!response.data.success) {
                console.error(response);
                handleError(response.data.msg);
            } else {
                setSeance({ ...seance, status: response.data.status });
                handleSuccess(response.data.msg);
            }
        }

        showModal('confirm', {
            message: "Êtes-vous sûr de vouloir valider l'appel pour cette séance (action définitive) ?",
            onConfirm: fetchThat,
        });
    }

    const reasons = [
        { value: "pas_assez_participant", label: "Pas assez de participant", classesbtn: "btn btn_main" },
        { value: "conditions_du_lieu", label: "Conditions du lieu", classesbtn: "btn btn_main" },
        { value: "materiel", label: "Matériel", classesbtn: "btn btn_main" },
        { value: "autre", label: "Autre", classesbtn: "btn btn_primary" },
    ]

    async function seanceImpossibleReq(reason) {
        const fetchThat = async () => {
            const response = await axiosConfig.post(`/seances/seance/impossible/${seance.id}`, { reason });

            if (!response.data.success) {
                console.error(response);
                handleError(response.data.msg);
            } else {
                setSeance({ ...seance, seance_impossible: response.data.seance_impossible });
                handleSuccess(response.data.msg);
            }
        }

        showModal('confirm', {
            message: 'Confirmer la raison "' + reasons.find(r => r.value === reason).label + '" ?',
            onConfirm: fetchThat,
        });
    }

    function seanceImpossible() {
        showModal('classic', {
            children:
                <div style={{maxWidth: "602px", height: "auto", padding: "60px", flexWrap: "wrap" }}>
                    <h3 className={"titleAlert"}>Pour quelle raison cette séance ne peut pas avoir lieu ?</h3>


                    <div className={styles_modal.btnChoiceBar} style={{ flexWrap: "wrap" }}>
                        {reasons.map((r) => (
                            <button key={r.value} className={r.classesbtn} style={{ width: "200px"}} onClick={() => seanceImpossibleReq(r.value)}>{r.label}</button>
                        ))}
                    </div>
                </div>
        });
    }

    async function coachAbsence() {
        const fetchThat = async () => {
            const response = await axiosConfig.post(`/seances/seance/absence/${seance.id}`);
            if (!response.data.success) {
                console.error("erreur:", response);
                handleError(response.data.msg);
            } else {
                setSeance({ ...seance, coach: { absence: response.data.absence} });
                handleSuccess(response.data.msg);
            }
        }

        showModal('confirm', {
            message: "Signalez votre absence pour cette séance (action définitive) ?",
            onConfirm: fetchThat,
        });
    }

    const handleToggleSwitchDesinscrireByReferent = async (key) => {
        const newListParticipants = listParticipants.map(item => {
            if (item.key === key) {
                return { ...item, isSwitchActive: !item.isSwitchActive };
            }
            return item;
        });

        const result = await setDesinscrireParticipantByReferent(key);
        if (result.success) {
            handleSuccess(result.msg);
            // Retirer l'élément de la liste si désinscrit
            if (!newListParticipants.find(item => item.key === key && item.isSwitchActive)) {
                const index = newListParticipants.findIndex(item => item.key === key);
                if (index !== -1) {
                    newListParticipants.splice(index, 1);
                }
            }
            setListParticipants(newListParticipants);
        } else {
            handleError(result.msg);
        }
    }

    const isSeanceAnnulee = () => {
      return seance.status === SEANCE_STATUS.annule.value;
    }

    const isAccesAnticipe = () => {
        const droit = seance.acces_anticipe !== null && new Date(seance.acces_anticipe) < new Date() && new Date(seance.periode_inscription) > new Date();
        return droit;
    }

    const isCoachAbsent = () => {
        return seance.coach.absence === true;
    }

    return (
        <div className="content">
            <div className={"content_sizer"}>
                {isSeanceAnnulee() ?
                    <p className={styles.seanceAnnuleeBandeau}>Cette séance est annulée</p> : null
                }
                {isAccesAnticipe() ?
                    <p className={styles.accesAnticipeBandeau} title={"Puisque vous n'avez jamais participé à cette activité, vous pouvez vous inscrire avant les autres."}>Accès anticipé aux inscriptions</p> : null
                }
                {isCoachAbsent() &&
                    <p className={styles.seanceCoachAbsent}>
                        <FontAwesomeIcon icon={faExclamation} className={"warning"} />
                        Vous avez signalé votre absence pour cette séance.
                    </p>
                }
                <TitleMain text={seance.titre}/>

                <ImageIllustration src={seance.image} alt={seance.title} />

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <BlocLocation lieu={seance.lieu}/>
                </div>

                <p className={styles.actDescription}>{seance.type.description}</p>

                <div className={styles.seance_info_container}>
                    <ul>
                        <li>
                            <FontAwesomeIcon icon={faPersonRunning}/>
                            <span className={styles.seance_info_label}>Coach:</span>
                            <span className={styles.seance_info_value}>{seance.coach.prenom}</span>
                        </li>

                        <li>
                            <FontAwesomeIcon icon={faCalendarAlt}/>
                            <span className={styles.seance_info_label}>Date: </span>
                            <span
                                className={styles.seance_info_value}>{DateService.formatDate(seance.date)}</span>
                        </li>

                        <li>
                            <FontAwesomeIcon icon={faClockRotateLeft}/>
                            <span className={styles.seance_info_label}>Durée: </span>
                            <span className={styles.seance_info_value}>{seance.duree} minutes</span>
                        </li>

                        <li className={seance.placesRestantes < 1 ? styles.seance_info_plusdeplace : "" }>
                            <FontAwesomeIcon icon={faChair}/>
                            <span className={styles.seance_info_label}>Places restantes: </span>
                            <span className={styles.seance_info_value}>{ seance.placesRestantes } / { seance.participantsMax }</span>
                        </li>
                    </ul>
                </div>

                <SeanceActions />

                {user.roles.includes('ROLE_COACH') &&
                    <div className={styles.coachBlocContainer}>
                        <ListSwitch
                            listData={listData.filter(item => item.status === PARTICIPATION_STATUS.valide.value)}
                            handleToggleSwitch={handleToggleSwitch}
                            title={"Participants"}
                            description={"Cochez les personnes présentes au cours"} />

                        <ListSwitch
                            listData={listData.filter(item => item.status === PARTICIPATION_STATUS.file_attente.value)}
                            handleToggleSwitch={handleToggleSwitch}
                            title={"Liste d'attente"}
                            description={"Cochez les personnes présentes au cours"} />

                        <ListSwitch
                            listData={listData.filter(item => item.status === PARTICIPATION_STATUS.file_attente_non_prio.value)}
                            handleToggleSwitch={handleToggleSwitch}
                            title={"Liste d'attente non prioritaire"}
                            description={"Cochez les personnes présentes au cours"} />

                        { seance.status === 1 && seance.coach.absence === false ?
                            <>
                                <AddPeopleForm id={seance.id} onSubmit={getSeanceData} entrepriseId={seance.entrepriseId} />

                                { (new Date(seance.date).getTime() < new Date().getTime()) &&
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                        <button className={`btn ${stylesForm.btnSubmitDanger} ${stylesForm.form}`} style={{ marginTop: "20px" }}
                                                onClick={validerAppel}>Valider l'appel
                                        </button>

                                        <span style={{ margin: "2px 0 30px 0" }}>OU</span>

                                        {seance?.seance_impossible ? <p style={{
                                            fontSize: ".9rem",
                                            fontStyle: "italic",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: "#fff4dc"
                                        }}>{seance?.seance_impossible}</p> : <button className={`btn ${stylesForm.btnSubmitDangerAlt} ${stylesForm.form}`}
                                                                                     onClick={seanceImpossible}>Cette séance ne peut pas avoir lieu ?
                                        </button>}
                                    </div>
                                }

                                { (new Date(seance.date).getTime() > new Date().getTime()) &&
                                    <button className={`warnBtn ${stylesForm.form}`} onClick={coachAbsence} style={{ marginTop: "20px" }}>
                                        <FontAwesomeIcon icon={faUserSlash} /> Je suis absent
                                    </button>
                                }
                            </>
                            :
                            seance.status === SEANCE_STATUS.valide ?
                                <p className={styles.statusMsg}><FontAwesomeIcon icon={faCheckCircle} style={{ color: "var(--clr-success)"}} /> L'appel a été validé</p> :
                                seance.status === SEANCE_STATUS.annule ?
                                    <p className={styles.statusMsg}><FontAwesomeIcon icon={faCircleExclamation} style={{ color: "var(--clr-danger)"}} />La séance est annulée</p> : null
                        }

                        <div className={"hide"}>
                            <TitleSecondary text="Envoyer un SMS aux participants" />

                            <Formik
                                initialValues={{ sender: user.id, sms: '' }}
                                onSubmit={async (values, {setSubmitting}) => {
                                    const response = await AxiosConfig.post(`/seances/seance/${seance.id}/send_sms`, values);
                                    if (response.data.success) {
                                        handleSuccess(response.data.message);
                                    } else {
                                        handleError(response.data.message);
                                    }

                                    setSubmitting(false);
                                }}
                            >
                                {({ handleSubmit, isSubmitting, setFieldValue }) => (
                                    <form onSubmit={handleSubmit} className={`spaceBottom ${styles.form}`}
                                          style={{textAlign: "center"}}>

                                        <TextAreaCustom
                                            id={"sms"}
                                            name={"sms"}
                                            label={""}
                                            placeholder={"Message ... (100 caractères max)"}
                                            onChange={(e) => {
                                                setSmsCharCount(e.target.value.length);
                                                setFieldValue('sms', e.target.value)
                                            }}
                                        />
                                        <span style={{fontSize: "var(--fs-secondary)"}}>{smsCharCount} / 100 caractères </span>

                                        <BtnSave text={"Envoyer"}/>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </div>
                }

                {afficherRating(seance) && (user.roles.includes('ROLE_COACH') || user.roles.includes('ROLE_REFERENT')) &&
                    <div>
                        { seance.averageRating ? <RatingBox
                        label="Note moyenne"
                        count={5}
                        value={seance.averageRating}
                        onChange={() => {}}
                        color="transparent"
                        filledColor={ getRatingColor(seance) }
                        hoverColor="#f1c40f"
                        disableHover={true}
                    /> : "Impossible d'obtenir la note moyenne : la séance n'a pas encore reçu de note" }
                    </div>
                }

                {user.roles.includes('ROLE_REFERENT') &&
                    <div className={stylesForm.form}>
                        <ListSwitch
                            listData={listParticipants}
                            handleToggleSwitch={handleToggleSwitchDesinscrireByReferent}
                            title={"Liste des participants"}
                            description={seance.status === SEANCE_STATUS.valide.value ? "Vérification des présences des participants" : "Décochez pour désinscrire un participant de la séance, un email lui sera envoyé pour l'informer de sa désinscription." }
                        />
                    </div>
                }

                {(user.roles.includes('ROLE_USER') || user.roles.includes('ROLE_REFERENT')) &&
                    <div className="signaler-link-container">
                        <Link to={Routing.generate({
                            route: Routing.routes.report,
                            queryParams: { from: encodeURIComponent(location.pathname + location.search) }
                        })} className="link">
                            <FontAwesomeIcon icon={faFlag} style={{ marginRight: "6px" }}/>
                            Signaler un problème
                        </Link>
                    </div>
                }
            </div>
        </div>
    )
}

export default SeancePage;
